module.exports = __webpack_public_path__ + "assets/img/worldviewImg-b6bf1f57.png";